requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xBadges', {
      loadingEl: new Set(),
      fixedPositionTemplate: `<div
        class="x-badge-{label-id} x-badge-container pointer-events-none{container-img-class} ltr"
        {preview-show-condition}
      >
        {content}
      </div>`,
      customPositionTemplate: `<div
        class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full pointer-events-none{container-css-class} ltr"
        x-data="{
          contentHeight: 1,
          rePosition() {
            this.$nextTick(() => {
              this.contentHeight = this.$refs.content ? this.$refs.content.offsetHeight : contentHeight;
            });
          }
        }"
        x-intersect.once="rePosition();
          if (Shopify.designMode) {
            window.addEventListener('resize', () => {
              if ($store.xBadges.lastWindowWidth != window.innerWidth) {
                rePosition();
              }
            });
          } else {
            installMediaQueryWatcher('(min-width: 768px)', (matches) => rePosition());
          }"
        {preview-show-condition}
        :style="'{css-position} min-height: ' + contentHeight + 'px'"
      >
        {content}
      </div>`,
      productDetailTemplate: `
      {teleport-template-open}
        <div
          class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full bottom-0 pointer-events-none{container-css-class}{container-img-class}"
          style="{css-position}"
          x-data="{
            contentHeight: 1,
            rePosition() {
              this.$nextTick(() => {
                this.contentHeight = this.$refs.content ? this.$refs.content.offsetHeight : contentHeight;
              });
            }
          }"
          x-intersect.once="rePosition();
            if (Shopify.designMode) {
              window.addEventListener('resize', () => {
                if ($store.xBadges.lastWindowWidth != window.innerWidth) {
                  rePosition();
                }
              });
            } else {
              installMediaQueryWatcher('(min-width: 768px)', (matches) => rePosition());
            }"
        >
          {content}
        </div>
      {teleport-template-close}
      `,
      outSideImageTemplate: `<div class="hidden" 
        x-data="{
          setPosition() {
            const element = $el.closest('.card-product').getElementsByClassName('{queryEL}');
            for (let i = 0; i < element.length; i++) {
              element[i].innerHTML += $el.innerHTML;
            }
          }
        }"
        x-init="setPosition()">
        <div
          class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full bottom-0 pointer-events-none{container-img-class}"
          {preview-show-condition}
        >
          {content}
        </div>
      </div>`,
      previewActiveBlock: window.xBadgesPreviewActiveBlock,
      init() {
        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            if (!event.target.classList.contains('x-badges-block-preview')) return;

            let blockId = event.target.getAttribute('block-id');
            this.previewActiveBlock = blockId;
            window.xBadgesPreviewActiveBlock = blockId;
            document.dispatchEvent(new CustomEvent("eurus:badges:block-select"));
          });
        }
      },
      load(el, callback = () => {}, container = null, productCard = false) {
        if (this.loadingEl.has(el)) return;
        this.loadingEl.add(el);
        if (container) el.container = container;

        const sliderEl = el.closest('[x-data-slider]');
        if (sliderEl) {
          if (!sliderEl.classList.contains('is-initialized')) {
            const sectionId = el.closest('[x-data-slider]').getAttribute('x-data-slider');
            document.addEventListener(`eurus:${sectionId}:splide-ready`, () => {
              this.doLoad(el, productCard, callback);
            });
          } else {
            this.doLoad(el, productCard, callback);
          }
        } else {
          this.doLoad(el, productCard, callback);
        }
        this.loadingEl.delete(el);
      },
      doLoad(el, productCard, callback = () => {}) {
        this.initAllLabels(el, productCard);

        if (Shopify.designMode) {
          let productData = xParseJSON(el.getAttribute('x-labels-data'));
          document.addEventListener('shopify:section:load', () => {
            if (productData && !productData.isXBadgesPreview) {
              this.initAllLabels(el, productCard);
            }
          });
        }

        callback(el);
      },
      initAllLabels(el, productCard) {
          let productDatas = xParseJSON(el.getAttribute('x-labels-data'));
          let allLabels = document.getElementsByClassName('x-badges-block-data');

          if (!productDatas) return;

          if (Shopify.designMode || productCard) {
            const cardProduct = el.closest('.card-product');
            if (cardProduct) {
              let currentLabels = cardProduct.getElementsByClassName('x-badge-container');
              while (currentLabels?.length > 0) {
                currentLabels[0].remove();
              }
            }
          }

          if (productCard) {
            requestAnimationFrame(() => {
              let variantId = null;
              const variantEl = el.closest('.card-product')?.querySelector(".current-variant");

              if (variantEl) {
                const currentVariant = JSON.parse(el.closest('.card-product')?.querySelector(".current-variant")?.textContent);
                variantId = (typeof currentVariant === 'object') ? currentVariant.id : currentVariant;
              }
              
              if (variantId) {
                productDatas.forEach(productData => {
                  if (productData.variant_id === Number(variantId)) {
                    const processedLabelIds = new Set();
                    for (let i = 0;i < allLabels.length;i++) {
                      const labelEl = allLabels[i];
                      const labelProductId = labelEl.getAttribute('data-product-id');
                      
                      if (labelProductId && labelProductId != productData.product_id) continue;
                      
                      let label = xParseJSON(labelEl.getAttribute('x-badges-block-data'));
                      if (!label.enable && !productData.isXBadgesPreview) return;
                      
                      if (processedLabelIds.has(label.id)) continue;
                      processedLabelIds.add(label.id);
                      
                      label.settings.icon = labelEl.getAttribute('x-badges-icon');
                      this.appendLabel(el, label, productData);
                    }  
                  }
                });    
              } else {
                const processedLabelIds = new Set();
                for (let i = 0;i < allLabels.length;i++) {
                  const labelEl = allLabels[i];
                  const labelProductId = labelEl.getAttribute('data-product-id');
                  
                  if (labelProductId && labelProductId != productDatas[0].product_id) continue;
                  
                  let label = xParseJSON(labelEl.getAttribute('x-badges-block-data'));
                  if (!label.enable && !productDatas[0].isXBadgesPreview) return;
                  
                  if (processedLabelIds.has(label.id)) continue;
                  processedLabelIds.add(label.id);
                  
                  label.settings.icon = labelEl.getAttribute('x-badges-icon');
                  this.appendLabel(el, label, productDatas[0]);
                }  
              }
            });
          } else {
            const currentProductId = productDatas.product_id;
            const processedLabelIds = new Set();
            
            for (let i = 0;i < allLabels.length;i++) {
              const labelEl = allLabels[i];
              const labelProductId = labelEl.getAttribute('data-product-id');
              
              if (labelProductId && labelProductId != currentProductId) continue;
              
              let label = xParseJSON(labelEl.getAttribute('x-badges-block-data'));
              if (!label.enable && !productDatas.isXBadgesPreview) return;
              
              if (processedLabelIds.has(label.id)) continue;
              processedLabelIds.add(label.id);
              
              label.settings.icon = labelEl.getAttribute('x-badges-icon');
              this.appendLabel(el, label, productDatas);
            }  

            el.removeAttribute('x-labels-data');
          }
      },
      appendLabel(el, label, productData) {
        if (productData.container == 'product-info') {
          el.innerHTML += this.processTemplate(el, label, productData);
          return;
        }

        if (label.settings.position == 'custom') {
          let container = el.querySelector(`.custom-label-container`);
          if (!container) {
            container = document.createElement("div");
            let HTMLClass = `custom-label-container pointer-events-none`;
            container.setAttribute('class', HTMLClass);
            el.appendChild(container);
          }
          container.innerHTML += this.processTemplate(el, label, productData);
          return;
        }

        let container = el.querySelector(`.${label.settings.position}-container`);
        if (!container) {
          container = this.createFixedPositionContainer(label.settings.position);
          el.appendChild(container);
        }

        container.innerHTML += this.processTemplate(el, label, productData);
      },
      createFixedPositionContainer(position) {
        let HTMLClass = `${position}-container label-container flex absolute gap-1 space-y-1`;
        if (position == 'bottom-right') {
          HTMLClass += ' bottom-10 right-0 flex-col items-end';
        } else {
          HTMLClass += position.includes('top') ? ' top-2 flex-col' : ' bottom-2 flex-col';
          HTMLClass += position.includes('left') ? ' items-start left-2' : ' items-end right-2';
        }

        container = document.createElement("div");
        container.setAttribute('class', HTMLClass);

        return container;
      },
      processContent(el, label, productData) {
        let content = false;
        const canShow = this.canShow(label, productData);

        if (label.settings.image && canShow) {
          /** image label */
          let imageHeight, imageWidth, imageWidthMobile, imageHeightMobile;
          const isMetaobject = label.id && label.id.includes('metaobject');
          
          imageWidth = label.settings.size * 15;
          imageHeight = imageWidth / label.settings.image_aspect_ratio;
          imageWidthMobile = label.settings.size_mobile * 15;
          imageHeightMobile = imageWidthMobile / label.settings.image_aspect_ratio;
          const maxImageWidth = Math.max(imageWidth, imageWidthMobile) * 3;
          let image;
          if (label.settings.image.src) {
            image = label.settings.image.src.includes('burst.shopifycdn.com') ? label.settings.image.src : 
            label.settings.image.src + `&width=` + maxImageWidth;
          } else {
            image = label.settings.image.includes('burst.shopifycdn.com') ? label.settings.image : 
            label.settings.image + `&width=` + maxImageWidth;
          }
          if (productData.container == "card") {
            var imageDirection = label.settings.position.includes('left') ? "justify-start" : "justify-end";
            const metaobjectClasses = isMetaobject ? 'max-w-full h-auto object-contain' : '';
            var styleImage = isMetaobject ? '' : `width: ${imageWidth}px; height: ${imageHeight}px;`;
          } else {
            var imageDirection = productData.make_content_center ? "justify-center" : "justify-start";
            if (isMetaobject) {
              var metaobjectClasses = 'max-w-full h-auto object-contain';
              var styleImage = '';
            } else {
              var styleImage = '';
              var metaobjectClasses = '';
            }
          }
          const metaobjectLabelClass = isMetaobject ? ' badge-metaobject-label' : '';
          const metaobjectContainerStyle = isMetaobject ? `style="--label-w-d: ${imageWidth}px; --label-h-d: ${imageHeight}px; --label-w-m: ${imageWidthMobile}px; --label-h-m: ${imageHeightMobile}px;"` : '';
          content = `<div x-ref="content" class='x-badge-content w-fit flex ${imageDirection}{css-opacity}${metaobjectLabelClass}' ${metaobjectContainerStyle}>
            <img 
              loading="lazy"
              width="` + imageWidth + `"
              height="` + imageHeight + `"
              alt="` + (label.settings.image_alt.length > 0 ? label.settings.image_alt : productData.title) + `"
              src="` + image + `"
              class="${metaobjectClasses}"
              style="${styleImage}"
            />
          </div>`;
        } else if (label.settings.content && canShow) {
          /** text label */
          const isMetaobject = label.id && label.id.includes('metaobject');
          const isNewLabel = label.type == 'new-label';
          const isNewLabelBottomRight = isNewLabel && label.settings.position == 'bottom-right';
          const isPDP = productData.container == 'product-info';
          const isSaleLabelTopLeft = label.type == 'sale-label' && label.settings.position == 'top-left';
          // On the wishlist page the sold-out label is drawn like the sale
          // badge: round, in Bodysuit, "SOLD" over "OUT" — wherever the theme
          // settings place it. Elsewhere it is unchanged.
          const isRoundSoldOut = label.type == 'sold-out-label'
            && !!(el && el.closest && el.closest('.wishlist-page'));
          let qty = (productData.inventory_management.length < 1 || productData.qty < 0) ? '' : productData.qty;
          let saleAmount = productData.sale_amount.includes('-') ? '' : productData.sale_amount;
          let countDown = label.settings.schedule_enabled ? '<span x-intersect.once="$nextTick(() => { if (typeof rePosition !== `undefined`) {rePosition()} });" class="x-badge-countdown-' + label.id + ' label-countdown empty:hidden"></span>' : '';
          let sale = Math.round((productData.compare_at_price - productData.price) * 100 / productData.compare_at_price);
          sale = sale == 100 ? 99 : sale;
          sale = sale > 0 ? sale + '%' : '';

          let originalContent = label.settings.content.replace(/{sale}/gi, sale)
                      .replace(/{sale_amount}/gi, saleAmount)
                      .replace(/{qty}/gi, qty)
                      .replace(/{price}/gi, productData.price_with_currency)
                      .replace(/{count_down}/gi, countDown);

          if (productData.metafield_label) {
            Object.entries(productData.metafield_label).forEach(([key, value]) => {
              originalContent = originalContent.replace(`{${key}}`, value);
            });
          }
          
          if (isRoundSoldOut) {
            const words = originalContent.replace(/<[^>]*>/g, '').trim().split(/\s+/).filter(Boolean);
            content = words.map((word) => `<span class="sold-out-word">${word}</span>`).join('');
          } else if (isSaleLabelTopLeft) {
            const saleMatch = originalContent.match(/(-?\d+%)/);
            if (saleMatch) {
              content = `<span class="sale-percentage">${saleMatch[1]}</span><span class="sale-off">OFF</span>`;
            } else {
              content = originalContent;
            }
          } else {
            content = originalContent;
          }
          const sizeClass = productData.container == 'product-info' ? '' : ` pt-1 pb-1 pl-2 pr-2`;
          const inlineStyle = productData.container == 'product-info' ? '' : `style="font-size: var(--font-size-scale);"`;
          const inlineStyleIcon = productData.container == 'product-info' ? '' : `style="height: var(--font-size-scale); width: var(--font-size-scale); min-width: var(--font-size-scale);"`;
          const metaobjectTextClasses = isMetaobject ? 'font-medium' : '';
          const metaobjectRoundedClasses = isMetaobject && cssType.includes('rounded-full') ? '!rounded-full aspect-square flex items-center justify-center min-w-[3.75rem] min-h-[3.75rem] py-2 px-3 md:min-w-[3.125rem] md:min-h-[3.125rem] md:py-1.5 md:px-2.5 md:text-sm' : '';
          
          let newLabelClasses = '';
          let newLabelStyle = inlineStyle;
          let saleLabelClasses = '';
          let saleLabelStyle = '';
          
          if (isNewLabel) {
            if (isPDP && isNewLabelBottomRight) {
              newLabelClasses = 'font-bold text-white w-136-5 md:w-265-3 badge-new-label-pdp-bottom-right';
              newLabelStyle = 'style="font-size: clamp(15px, 2vw, 30px);"';
            } else if (isNewLabelBottomRight) {
              newLabelClasses = 'font-bold text-white badge-new-label-bottom-right';
              newLabelStyle = 'style="font-size: clamp(10px, 2vw, 19px);"';
            } else {
              newLabelClasses = 'font-bold text-white';
              newLabelStyle = 'style="font-size: clamp(10px, 2vw, 19px);"';
            }
          }
          
          if (isRoundSoldOut) {
            saleLabelClasses = 'rounded-full flex flex-col items-center justify-center text-white font-bodysuit font-medium gap-0 badge-sale-label-top-left badge-sold-out-round';
          } else if (isSaleLabelTopLeft) {
            saleLabelClasses = 'rounded-full flex flex-col items-center justify-center text-white font-bodysuit font-medium gap-0 badge-sale-label-top-left';
            if (isPDP) {
              saleLabelClasses += ' badge-sale-label-pdp';
            }
          }
          
          const isRoundBadge = isSaleLabelTopLeft || isRoundSoldOut;
          const gapClass = isRoundBadge ? ' gap-0' : ' gap-2';
          const textSpanClasses = isRoundBadge ? 'leading-none w-full flex flex-col items-center justify-center' : 'leading-normal w-fit p-break-words';
          const sizeClassOverride = isNewLabelBottomRight && !isPDP ? '' : (isRoundBadge ? '' : sizeClass);
          content = content.length > 0
            ? `<div
                x-ref="content"
                class='x-badge-content ltr x-badge-text select-none inline-flex justify-center${sizeClassOverride} items-center{css-opacity}{css-type}${gapClass} ${metaobjectTextClasses} ${metaobjectRoundedClasses} ${newLabelClasses} ${saleLabelClasses}'
                ${newLabelStyle}
              ><span class="icon-label empty:hidden" ${inlineStyleIcon}>${label.settings.icon}</span><span class="${textSpanClasses}">${content}</span></div>` : false;

          if (countDown.length > 0 && label.settings.schedule_enabled) {
            Alpine.store('xHelper').countdown(label.settings, function(canShow, seconds, minutes, hours, days) {
              let container;
              if (productData.container === "card") {
                container = el.container ? el.container : el;
                if (label.settings.position == "below-image" || label.settings.position == "bottom-card") {
                  container = el.closest('.card-product')
                }
              } else {
                if (label.settings.position == "next-price") {
                  container = document.querySelector(productData.teleport_dest_price);
                } else if (label.settings.position == "below-image" || label.settings.position == "bottom-card") {
                  container = el.container ? el.container : el;
                } else {
                  container = document.querySelector(productData.teleport_dest_image);
                }
              }

              const countdownElements = container?.getElementsByClassName('x-badge-countdown-' + label.id);
              if (!canShow) {
                for (let i = 0;i < countdownElements?.length;i++) {
                  countdownElements[i].innerHTML = '';
                }
                return;
              }
              days = days > 0 ? days + "D&nbsp;&nbsp;&nbsp;" : "";
              hours = hours == 0 && days.length == 0 ? "" : hours + " : ";
              const timeLeft = days + hours + minutes + " : " + seconds;
              for (let i = 0;i < countdownElements?.length;i++) {
                countdownElements[i].innerHTML = timeLeft;
              }
            });
          }
        }
        return content;
      },
      processTemplate(el, label, productData) {
        let template = '';
        let teleportTemplateOpen = '';
        let teleportTemplateClose = '';
        if (content = this.processContent(el, label, productData)) {
          const cssOpacity = " opacity-" + label.settings.opacity;
          let cssPosition = ''
          let containerCssClass = ''
          const isSaleLabelTopLeft = label.type == 'sale-label' && label.settings.position == 'top-left';
          const isRoundSoldOut = label.type == 'sold-out-label'
            && !!(el && el.closest && el.closest('.wishlist-page'));

          if (productData.container == "product-info" && label.settings.position == "custom" && productData.position_adapt) {
            cssPosition = "left: " + label.settings.horizontal_position + "%;" + " transform: translate(-" + label.settings.horizontal_position+"%, -" + label.settings.vertical_position+"%);" + " top: " + (label.settings.vertical_position) + "%;";
          } else {
            cssPosition = productData.container == "card" ? "left: " + label.settings.horizontal_position + "%;" + " transform: translate(-"+ label.settings.horizontal_position+"%, -"+ label.settings.vertical_position+"%);"
            + " top: " + (label.settings.vertical_position) + "%;"
            : "";
          }
          let cssType = '';
          if (isSaleLabelTopLeft || isRoundSoldOut) {
            cssType = ' rounded-full';
          } else {
            if (label.settings.type == 'round') cssType = ' rounded-md';
            if (label.settings.type == 'rounded-full') cssType = ' rounded-full';
          }

          if (productData.container === "card") {
            containerCssClass = " absolute w-max";
          } else if (productData.position_adapt) {
            containerCssClass = (label.settings.position === "custom") ? " absolute w-max h-fit product-info-custom-label" : " w-fit h-fit product-info-custom-label";
          }

          if (productData.container == "product-info" && productData.position_adapt) {
            if (productData.teleport_dest_price || productData.teleport_dest_image) {
              teleportTemplateClose = "</template>"
            }
            if (label.settings.position == "next-price") {
              if (productData.teleport_dest_price) {
                teleportTemplateOpen = `<template x-teleport="${productData.teleport_dest_price}">`;
              }
            } else if (label.settings.position == "custom") {
              if (productData.teleport_dest_image) {
                teleportTemplateOpen = `<template x-teleport="${productData.teleport_dest_image}">`
              }
            } else if (label.settings.position == "below-image" || label.settings.position == "bottom-card") {
              teleportTemplateOpen = "";
              teleportTemplateClose = "";
            } else {
              const imageContainer = document.querySelector(productData.teleport_dest_image);
              let container = imageContainer.querySelector(`.${label.settings.position}-container`);
              if (!container) {
                container = this.createFixedPositionContainer(label.settings.position);
                imageContainer.appendChild(container);
              }
              if (productData.teleport_dest_image) {
                teleportTemplateOpen = `<template x-teleport="${productData.teleport_dest_image} .${label.settings.position}-container">`
              }
            }
          }

          containerCssClass += label.settings.horizontal_position > 50 ? " text-end" : " text-start";
          const previewShowCondition = productData.isXBadgesPreview ? `x-show="$store.xBadges.previewActiveBlock == '{label-id}'"` : '';
          let imgClass;
          if (productData.container == "product-info" && (label.settings.position == "below-image" || label.settings.position == "bottom-card" || !productData.position_adapt)) {
            let imageContainerAlignment = productData.make_content_center ? 'flex justify-center' : ''
            imgClass = label.settings.image ? ` label-img ${imageContainerAlignment}` : '';
          } else {
            imgClass = label.settings.image ? ' label-img' : '';
          }

          template = this.getLableTemplate(productData.container, label.settings.position);
          template = template.replace('{preview-show-condition}', previewShowCondition)
            .replace('{content}', content)
            .replace('{css-opacity}', cssOpacity)
            .replace('{css-position}', cssPosition)
            .replace('{css-type}', cssType)
            .replace('{container-css-class}', containerCssClass)
            .replace('{container-img-class}', imgClass)
            .replace('{teleport-template-open}', teleportTemplateOpen)
            .replace('{teleport-template-close}', teleportTemplateClose)
            .replace(/{label-id}/gi, label.id);
        }
        return template;
      },
      getLableTemplate(container, position) {
        if (container == 'product-info') {
          return this.productDetailTemplate;
        } else if (position == 'custom') {
          return this.customPositionTemplate;
        } else if (position == 'below-image' || position == 'bottom-card' || position == 'next-price') {
          return this.outSideImageTemplate.replace('{queryEL}', position);
        }

        return this.fixedPositionTemplate;
      },
      canShow(label, productData) {
        if (productData.isXBadgesPreview) {
          return true;
        }

        if (productData.container == 'card' && !label.settings.show_on_product_card) {
          return false;
        }

        if (productData.container == 'product-info' && !label.settings.show_on_product_page) {
          return false;
        }

        if (label.type == "sale-label" && productData.compare_at_price > productData.price) {
          return true;
        }

        if (label.type == "sold-out-label" && !productData.available) {
          return true;
        }
        if (label.type == "preorder-label" ) {
          if (productData.can_show_preorder && productData.available) {
            return true;
          } else {
            return false;
          }
        }
        if (label.type == "new-label" ) {
          if (label.settings.day_since == 'creation_date' && label.settings.number_show < productData.diff_day_create) {
            return false;
          } else if (label.settings.day_since == 'activation_date' && label.settings.number_show < productData.diff_day_publish) {
            return false;
          }
        }

        if (label.settings.schedule_enabled) {
          let endDate = new Date(
            label.settings.end_year,
            label.settings.end_month - 1,
            label.settings.end_day,
            label.settings.end_hour,
            label.settings.end_minute
          );
          label.endTime = endDate.getTime()
            + (-1 * label.settings.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;
  
          let startDate = new Date(
            label.settings.start_year,
            label.settings.start_month - 1,
            label.settings.start_day,
            label.settings.start_hour,
            label.settings.start_minute
          );
          label.startTime = startDate.getTime()
            + (-1 * label.settings.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;

          let now = new Date().getTime();
          if (label.endTime < now) {
            return false;
          }

          if (label.startTime > now) {
            return false;
          }
        }
        
        if (label.type != "sale-label"
          && label.type != "sold-out-label"
          && (label.settings.apply_to_all_products || label.settings.apply_to_all_collections)) {
          return true;
        }

        if (label.settings.applied_products.includes(productData.product_id)) {
          return true;
        }

        for(let i=0;i<label.settings.applied_collections.length;i++) {
          if (productData.collections.includes(label.settings.applied_collections[i])) {
            return true;
          }
        }

        return false;
      }
    });
  });
});
